export default {
  PAGE_NAME: 'Persetujuan',
  REGISTRATION_PAGE: 'Registrasi',
};
